import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';

import { IReportsActions, IReportsStore, IThunkGetClientAllocationVisitsReport } from '../types';

const onGetClientAllocationVisitsReport: IThunkGetClientAllocationVisitsReport = thunk(
  async (
    { setClientAllocationVisitsReport }: Actions<IReportsActions>,
    { requestInfo, params, signal },
    { getState },
  ) => {
    const localState = getState() as IReportsStore;

    const currentTeams = localState.clientAllocationVisits?.filters?.teamIds || [];

    const clientAllocationVisits = await api.reports
      .getClientAllocationVisitsReport(requestInfo, params, signal)
      .then(r => r.data);

    const clientAllocationVisitsFiltered =
      clientAllocationVisits?.teams?.filter(team => currentTeams.includes(team.id)) || [];

    // skip applying data if filter has already been changed
    if (!clientAllocationVisitsFiltered.length) {
      return;
    }

    setClientAllocationVisitsReport({
      ...clientAllocationVisits,
      teams: clientAllocationVisitsFiltered,
      filters: localState.clientAllocationVisits.filters,
    });
  },
);

export default onGetClientAllocationVisitsReport;
